export function CallController() {
    /**
     * Dummy function to set Call listener object
     */
    this.setCallListener = function(callListener) {
        this.callListener = callListener;
    }
}